import CommonLoadingAnimation from '@/shared/components/CommonLoadingAnimation';
import { useZoomConnectOverlayStore } from '@/shared/store/zoomConnectOverlayStore';
import { createPortal } from 'react-dom';

/** Zoom 계정 연결(웹 팝업) 흐름 전용 오버레이 — 앱 전체가 공유하는 GlobalLoadingOverlay와는 별개다. */
export default function ZoomConnectOverlay() {
  const isVisible = useZoomConnectOverlayStore((state) => state.isVisible);

  return createPortal(isVisible && <CommonLoadingAnimation fullPage={true} size='10rem' text='Zoom 연결 확인 중...' />, document.body);
}
